<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.set_sharing_project_percent') }}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.project_with_percent')">
          <div v-for="(item,index) in form.target_project_percent" :key="index" class="d-flex align-items-center">
            <a-form-model-item :prop="`target_project_percent.${index}.project_id`" :rules="rules.project_id" style="flex: 0 0 430px">
              <base-select
                v-model="item.project_id"
                resource="projects"
                :params="{ ...projectParams, $t: index }"
                remote
                @update:item="val => projectChange(val, index)" />
            </a-form-model-item>
            <a-form-model-item class="ml-2" :prop="`target_project_percent.${index}.percent`" :rules="rules.percent">
              <a-input-number v-model="item.percent" :max="100" :min="0" @change="percentChange" /><span class="ml-2">%</span>
            </a-form-model-item>
            <a-form-model-item v-if="form.target_project_percent.length > 1">
              <a-button @click="handleRemove(index)" shape="circle" icon="minus" size="small" class="mt-2 ml-2" />
            </a-form-model-item>
          </div>
        </a-form-model-item>
        <a-button style="margin-left: 150px" type="link" @click="addRule">{{ $t('common.new') }}</a-button>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SharingSetProjectPercentDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { target_project_percent = [{ project_id: '', percent: '' }] } = this.params.param
    return {
      loading: false,
      form: {
        target_project_percent: target_project_percent.length ? target_project_percent : [{ project_id: '', percent: '' }],
      },
      rules: {
        project_id: [{ required: true, message: this.$t('common.tips.select', [this.$t('dictionary.project')]) }],
        percent: [{
          required: true,
          validator: (rule, value, callback) => {
            let rate = 0
            this.form.target_project_percent.map(item => {
              rate += item.percent
            })
            if (rate !== 100) {
              callback(new Error(this.$t('bill.rate_need_100')))
            }
            callback()
          },
        }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      tagValueOpts: [],
    }
  },
  computed: {
    projectParams () {
      return {
        scope: this.$store.getters.scope,
        limit: 20,
      }
    },
  },
  created () {
    this.$tM = new this.$Manager('identity-metadatas/tag-value-pairs')
    if (!this.params.param.tag_key) {
      this.form.tag_values = []
    }
  },
  methods: {
    addRule () {
      this.form.target_project_percent.push({ project_id: '', percent: '' })
    },
    handleRemove (index) {
      this.form.target_project_percent = this.form.target_project_percent.filter((item, idx) => idx !== index)
    },
    projectChange (val, index) {
      this.form.target_project_percent[index].project_name = val.name
    },
    percentChange () {
      this.$nextTick(() => {
        this.form.target_project_percent.forEach((item, index) => {
          this.$refs.form.validateField(`target_project_percent.${index}.percent`)
        })
      })
    },
    // fetchTags () {
    //   try {
    //     this.loading = true
    //     await this.$pM.list({
    //       params: {
    //         limit: 0,
    //         scope: this.$store.getters.scope,
    //         offset: 0,

    //       }
    //     })
    //   } catch (err) {
    //     this.loading = false
    //     throw error
    //   }
    // },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const validate = await this.validateForm()
        if (!validate) return
        this.params.update(this.form.target_project_percent)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
